<!-- savings-goal.html (no changes) -->
<div class="savings-plans-widget" (click)="openModal()">
  <!-- Header -->
  <div class="savings-header">
    <div class="savings-title">Savings Plans</div>
    <ng-container *ngIf="isEditMode">
      <div class="pencil-wrapper" (click)="toggleSizeDropdown(index, $event); $event.stopPropagation()" cdkOverlayOrigin
        #editTrigger="cdkOverlayOrigin">
        <img src="assets/icons/img-pencil.svg" class="pencil-icon" alt="Edit size" />
      </div>
      <!-- Size Dropdown -->
      <app-widget-edit [editTrigger]="editTrigger" [index]="index" [activeDropdownIndex]="activeDropdownIndex"
        [getAvailableSizes]="getAvailableSizes" [changeWidgetSize]="changeWidgetSize" [removeWidget]="removeWidget"
        [toggleSizeDropdown]="toggleSizeDropdown">
      </app-widget-edit>
    </ng-container>
    <ng-container *ngIf="isAddMode">
      <img class="add-widget-btn-icon no-dark-filter" src="assets/icons/img_frame-1171275385.png" alt="Settings"
        (click)="addWidget.emit(); $event.stopPropagation()" />
    </ng-container>
  </div>

  <!-- Main Content -->
  <div class="savings-main">
    <!-- Top Section: Plan Name + Amount + Saved -->
    <div class="top-section">
      <div class="plan-row">
        <img src="assets/icons/img-target-05.svg" />
        <div class="plan-name">Retirement</div>
      </div>

      <div class="amount" [class.size]="size === 'small'">₹700,425.35</div>

      <div class="saved-label">saved</div>
    </div>

    <!-- Bottom Section: Goal + Progress + Achieved -->
    <div class="bottom-section">
      <div class="goal-row">
        <span class="goal-text">Daily Goal</span>
        <span class="dot"></span>
        <span class="goal-amount">₹600,000</span>
      </div>

      <div class="progress-container">
        <div class="progress-bg"></div>
        <div class="progress-fill"></div>
      </div>

      <div class="achieved-row">
        <span class="achieved-text">achieved</span>
        <span class="dot green"></span>
        <span class="achieved-percent">40%</span>
      </div>
    </div>
  </div>
</div>